import React, { useState, useEffect } from 'react';
import { Button, Form, Input, Select, App, DatePicker, Upload, Modal } from 'antd';
import { CalendarOutlined, PlusOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import type { UploadProps, UploadFile, GetProp } from 'antd';
import styles from './StoreEntryStep3.module.scss';
import { useAppSelector, useAppDispatch } from '@/store/hooks';
import { IFormDataAll } from '../../types';
import { saveApplyMerchant } from '@/api/store';
import { setUserInfo } from '@/store/slices/userSlice';
import CookieUtil from '@/utils/cookies';
import { useTranslation } from 'react-i18next';
export interface StoreEntryStep3Props {
  onNext?: (submitData: any) => void;
  onPrev?: () => void;
  onCancel?: () => void;
  storeType?: 'individual' | 'business';
  formData?: IFormDataAll;
}

const { Option } = Select;

//文件类型
type FileType = Parameters<GetProp<UploadProps, 'beforeUpload'>>[0];

// 店铺入驻第三步：身份确认
const StoreEntryStep3: React.FC<StoreEntryStep3Props> = ({
  onNext,
  onPrev,
  onCancel,
  storeType = 'business', // 默认为企业类型
  formData
}) => {
  const { message } = App.useApp();
  //美国州列表
  const StateList = useAppSelector((state) => state.common.StateList);
  const userInfo = useAppSelector((state) => state.user.userInfo);
  const dispatch = useAppDispatch();

  const [form] = Form.useForm();


   //国际化语言切换
  const { t, i18n } = useTranslation();

  // 文件上传状态
  const [governmentIdFileList, setGovernmentIdFileList] = useState<any[]>([]);
  const [certificateFileList, setCertificateFileList] = useState<any[]>([]);
  
  // Beneficial Owners 状态
  const [beneficial_owners, setBeneficialOwnersList] = useState<any[]>([
    {
      full_legal_name: "",
      date_of_birth: "",
      ownership_percentage: "",
      government_id_type: "",
      id_number: "",
      government_id_upload: [],
    }
  ]);

  // 添加预览状态变量
  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewImage, setPreviewImage] = useState('');
  const [previewTitle, setPreviewTitle] = useState('');

  //获取token
  const token = useAppSelector((state) => state.user.token);

  // 添加 Beneficial Owner
  const addBeneficialOwner = () => {
    const newOwner = {
      full_legal_name: "",
      date_of_birth: "",
      ownership_percentage: "",
      government_id_type: "",
      id_number: "",
      government_id_upload: [],
    };
    setBeneficialOwnersList([...beneficial_owners, newOwner]);
  };

  // 删除 Beneficial Owner
  const removeBeneficialOwner = (index: number) => {
    if (beneficial_owners.length > 1) {
      const newList = beneficial_owners.filter((_, i) => i !== index);
      setBeneficialOwnersList(newList);
    }
  };

  // 更新 Beneficial Owner 数据
  const updateBeneficialOwner = (index: number, field: string, value: any) => {
    const newList = [...beneficial_owners];
    // 如果是日期字段，确保值是有效的 dayjs 对象
    if (field === 'date_of_birth') {
      newList[index] = { ...newList[index], [field]: value && dayjs(value) ? value : undefined };
    } else {
      newList[index] = { ...newList[index], [field]: value };
    }
    setBeneficialOwnersList(newList);
    // 同步到表单值，确保提交与回显一致
    form.setFieldsValue({ beneficial_owners: newList });
  };

  // 文件上传配置
  const createUploadProps = (fileList: any[], setFileList: (list: any[]) => void): UploadProps => ({
    name: 'file',
    action: `${process.env.REACT_APP_API_URL}/api/product/save_upload_file`,
    accept: ".png,.jpeg,.jpg,.gif",
    headers: {
      token: `${token}`,
    },
    listType: 'picture-card',
    maxCount: 1,
    showUploadList: true,
    fileList: fileList,
    beforeUpload: (file) => {
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isLt10M) {
        message.error("Image must be smaller than 10MB!");
      }
      return isLt10M; // 返回 false 阻止上传
    },
    onChange(info) {
      const newFileList = Array.isArray(info.fileList) ? [...info.fileList] : [];
      newFileList.forEach(file => {
        if (file.response) {
          file.url = file?.response?.data?.url;
        }
      });

      console.log('newFileList111',newFileList);
      setFileList(newFileList);

      if (info.file.status === 'done') {
        console.log('File uploaded successfully');
      } else if (info.file.status === 'error') {
        message.error(`${info.file.name} file upload failed.`);
      }
    },
    async onPreview(file: UploadFile) {
      let src = file.url as string;
      if (!src) {
        src = await new Promise((resolve) => {
          const reader = new FileReader();
          reader.readAsDataURL(file.originFileObj as FileType);
          reader.onload = () => resolve(reader.result as string);
        });
      }
      setPreviewImage(src);
      setPreviewVisible(true);
      setPreviewTitle(file.name || '图片预览');
    }
  });

  // 处理提交
  const handleSubmit = () => {
    form.validateFields().then(values => {
      console.log('Form values:', values);
      
      // 验证受益所有人持股比例总和
      if (values.beneficial_owners && values.beneficial_owners.length > 0) {
        const totalPercentage = values.beneficial_owners.reduce((sum: number, owner: any) => {
          const percentage = parseFloat(owner.ownership_percentage) || 0;
          return sum + percentage;
        }, 0);

        if (totalPercentage > 100) {
          message.error('所有受益所有人的持股比例总和不能超过100%');
          return;
        }
      }




      // if (storeType === 'business') {

      //   if (certificateFileList.length === 0) {
      //     message.error('Please upload at least one image1');
      //     return;
      //   }

      //   if (proofFileList.length === 0) {
      //     message.error('Please upload at least one image2');
      //     return;
      //   }

      // } else {
      //   if (governmentIdFileList.length === 0) {
      //     message.error('Please upload at least one image3');
      //     return;
      //   }
      // }

      // 规范化 Beneficial Owners 数据
      const beneficialOwnersData = (values.beneficial_owners || []).map((item: any) => ({
        full_legal_name: item?.full_legal_name?.trim() || '',
        date_of_birth: item?.date_of_birth ? dayjs(item.date_of_birth).format('YYYY-MM-DD') : '',
        ownership_percentage: item?.ownership_percentage ?? '',
        government_id_type: item?.government_id_type ?? '',
        id_number: item?.id_number ?? '',
        government_id_upload: (Array.isArray(item?.government_id_upload) ? item.government_id_upload : []).map((file: any) => ({
          uid: file?.uid,
          url: file?.url,
          status: 'done' as const,
          file_id: file?.uid || null,
        })),
      }));

      const submitData = {
        ...values,
    
        certificate_of_insurance: certificateFileList.map(file => ({
          uid: file.uid,
          url: file.url,
          status: 'done' as const,
          file_id: file.uid || null,
        })),
        beneficial_owners: beneficialOwnersData,
        government_id_upload: governmentIdFileList.map(file => ({
          uid: file.uid,
          url: file.url,
          status: 'done' as const,
          file_id: file.uid || null,
        }))
        
      }

      console.log('Form values:', submitData);
      onNext && onNext(submitData);

      // saveApplyMerchant(submitData).then(res => {
      //   console.log('res:', res);
      //   if(res.code === 200){
      //     //debugger;
      //     // 更新用户信息
      //     const returnedMerchantId = res?.data?.merchant_id ?? res?.merchant_id ?? res?.data?.id;
      //     if (returnedMerchantId !== undefined) {
      //       const mergedUserInfo = { ...(userInfo || {}), merchant_id: returnedMerchantId } as any;
      //       CookieUtil.set('userInfo', mergedUserInfo, { expires: 7 });
      //       dispatch(setUserInfo(mergedUserInfo));
      //     }
      //     onNext && onNext(values);
      //   }else{
      //     message.error(res.message);
      //   }
      // });

      
    }).catch(err => {
      console.error('Validation failed:', err);
    });
  };

   // 初始化表单数据 编辑回传
   useEffect(() => {
    // 如果有formData，则填充表单
    if (formData) {

      // Beneficial Owners 回填，mapping government_id_upload 为 Upload 文件对象
      let processedOwners: any[] | undefined = undefined;
      if (Array.isArray(formData.beneficial_owners) && formData.beneficial_owners.length > 0) {
        processedOwners = formData.beneficial_owners.map((owner: any, ownerIdx: number) => ({
          ...owner,
          date_of_birth: owner?.date_of_birth ? (dayjs(owner.date_of_birth) as any) : undefined,
          government_id_upload: (Array.isArray(owner?.government_id_upload) ? owner.government_id_upload : []).map((item: any, i: number) => ({
            uid: item?.uid ?? `${ownerIdx}-${i}`,
            file_id: item?.uid || null,
            name: `image-${i}.png`,
            status: 'done' as const,
            url: item?.url,
          })) as any[],
        }));
      }

      setTimeout(() => {
        form.setFieldsValue({
          ...formData,
          ...(processedOwners ? { beneficial_owners: processedOwners } : {}),
         });
        if (processedOwners) {
          setBeneficialOwnersList(processedOwners);
        }
        // 强制更新表单
        form.validateFields();
      }, 100);

      // 处理文件上传回填
      if (formData.certificate_of_insurance && formData.certificate_of_insurance.length > 0) {
        const images = formData.certificate_of_insurance.map((item: any, index: number) => ({
          uid: item.uid,
          file_id: item.uid || null,
          name: `image-${index}.png`,
          status: 'done' as const,
          url: item.url,
        })) as any[];
        console.log('images', images);

        setCertificateFileList(images);
      }


      // 处理文件上传回填
      if (formData.government_id_upload && formData.government_id_upload.length > 0) {
        const images = formData.government_id_upload.map((item: any, index: number) => ({
          uid: item.uid,
          file_id: item.uid || null,
          name: `image-${index}.png`,
          status: 'done' as const,
          url: item.url,
        })) as any[];
        console.log('images', images);

        setGovernmentIdFileList(images);
      }

      
    }
  }, [formData]);

  // 渲染企业表单
  const renderBusinessForm = () => {
    return (
      <>
        <div className={styles['section-title']}>{t('StoreEntryStep3.IdentityCompliance')}</div>

        <div className={styles['form-row']}>
          <Form.Item
            name="company_name"
            label={<span className={styles['required-label']}>*{t('storeEntry.CompanyLegalName')}</span>}
            rules={[{ required: true, message: t('storeEntry.entercompanylegalname') }]}
            className={styles['form-item-half']}
          >
            <Input placeholder={t('storeEntry.CompanyLegalName')} />
          </Form.Item>

          <Form.Item
            name="doing_business_as"
            label={<span className={styles['required-label']}>*{t('storeEntry.DoingBusinessAs')}</span>}
            rules={[{ required: true, message: t('storeEntry.enterdoingbusinessas') }]}
            className={styles['form-item-half']}
          >
            <Input placeholder={t('storeEntry.DoingBusinessAs')} />
          </Form.Item>
        </div>

        <div className={styles['form-row']}>
          <Form.Item
            name="entity_type"
            label={<span className={styles['required-label']}>{t('StoreEntryStep3.EntitType')}</span>}
            rules={[{ required: true, message: t('storeEntry.Pleaseselectentitytype') }]}
            className={styles['form-item-half']}
          >
            <Select placeholder={t('storeEntry.Pleaseselect')}>
              <Option value="Sole Prop">{t('StoreEntryStep3.SoleProp')}</Option>
              <Option value="LLC">{t('StoreEntryStep3.LLC')}</Option>
              <Option value="Corp">{t('StoreEntryStep3.Corp')}</Option>
              <Option value="Partnership">{t('StoreEntryStep3.Partnership')}</Option>
            </Select>
          </Form.Item>

          <Form.Item
            name="state_of_registration"
            label={<span className={styles['required-label']}>*{t('storeEntry.StateOfRegistration')}</span>}
            rules={[{ required: true, message: t('storeEntry.Pleaseselectstateofregistration') }]}
            className={styles['form-item-half']}
          >
            <Select placeholder={t('storeEntry.Pleaseselect')}>
              {StateList.map((item, index) => (
                <Option value={item.value} key={index}>{item.label}</Option>
              ))}
            </Select>
          </Form.Item>
        </div>

        <div className={styles['form-row']}>
          <Form.Item
            name="registration_number"
            label={<span className={styles['required-label']}>*{t('storeEntry.RegistrationNumber')}</span>}
            rules={[{ required: true, message: t('storeEntry.Pleaseenterregistrationnumber') }]}
            className={styles['form-item-half']}
          >
            <Input placeholder={t('storeEntry.RegistrationNumber')} />
          </Form.Item>

          <Form.Item
            name="ein"
            label={<span className={styles['required-label']}>*{t('storeEntry.EIN')}</span>}
            rules={[{ required: true, message: t('storeEntry.PleaseenterEIN') }]}
            className={styles['form-item-half']}
          >
            <Input placeholder={t('storeEntry.EIN')} />
          </Form.Item>
        </div>

        <div className={styles['form-row']}>
          <Form.Item
            name="website"
            label={<span className={styles['required-label']}>*{t('storeEntry.Website')}</span>}
            rules={[{ required: true, message: t('storeEntry.Pleaseenterwebsite') }]}
            className={styles['form-item-half']}
          >
            <Input placeholder={t('storeEntry.Website')} />
          </Form.Item>

          <Form.Item
            name="business_phone"
            label={<span className={styles['required-label']}>*{t('storeEntry.BusinessPhone')}</span>}
            rules={[{ required: true, message: t('storeEntry.Pleaseenterbusinessphone') }]}
            className={styles['form-item-half']}
          >
            <Input placeholder={t('storeEntry.BusinessPhone')} />
          </Form.Item>
        </div>

        <div className={styles['form-row']}>
          <Form.Item
            name="tax_settings"
            label={<span className={styles['required-label']}>{t('StoreEntryStep3.TaxSettings')}</span>}
            rules={[{ required: true, message: t('storeEntry.Pleaseselecttaxsettings') }]}
            className={styles['form-item-half']}
          >
            <Select placeholder={t('storeEntry.Pleaseselect')}>
              <Option value="Collect & Remit Sales Tax">{t('StoreEntryStep3.Collectax')}</Option>
              <Option value="Self-Collect Sales Tax">{t('StoreEntryStep3.SelfTax')}</Option>
            </Select>
          </Form.Item>

          <Form.Item
            name="certificate_of_insurance"
            label={<span className={styles['required-label']}>*{t('storeEntry.CertificateOfInsurance')}</span>}
            rules={[{ required: true, message: t('storeEntry.Pleaseuploadcertificateofinsurance') }]}
            className={styles['form-item-half']}
          >
            <Upload {...createUploadProps(certificateFileList, setCertificateFileList)}>
              <div className={styles['upload-button']}>
                <PlusOutlined />
                <div>{t('StoreEntryStep3.Upload')}</div>
              </div>
            </Upload>
          </Form.Item>
        </div>

        <div className={styles['section-title']}>{t('StoreEntryStep3.BeneficialOwners')}</div>

        {beneficial_owners.map((owner, index) => (
          <div key={index} className={styles['beneficial-owner-item']}>
            <div className={styles['owner-header']}>
              <h4>{t('storeEntry.BeneficialOwner')} {index + 1}</h4>
              {beneficial_owners.length > 1 && (
                <Button 
                  type="link" 
                  danger 
                  onClick={() => removeBeneficialOwner(index)}
                  className={styles['remove-button']}
                >
                  {t('common.Delete')}
                </Button>
              )}
            </div>

            <div className={styles['form-row']}>
              <Form.Item
                name={['beneficial_owners', index, 'full_legal_name']}
                label={<span className={styles['required-label']}>{t('StoreEntryStep3.FullName')}</span>}
                rules={[{ required: true, message: t('StoreEntryStep3.Pleaselename') }]}
                className={styles['form-item-half']}
                initialValue={owner.full_legal_name}
              >
                <Input 
                  placeholder={t('StoreEntryStep3.FullName')}
                  value={owner.full_legal_name}
                  onChange={(e) => updateBeneficialOwner(index, 'full_legal_name', e.target.value)}
                />
              </Form.Item>

              <Form.Item
                name={['beneficial_owners', index, 'date_of_birth']}
                label={<span className={styles['required-label']}>*{t('StoreEntryStep3.DateBirth')}</span>}
                rules={[{ required: true, message: t('StoreEntryStep3.Pleasebirth') }]}
                className={styles['form-item-half']}
                initialValue={owner.date_of_birth && dayjs(owner.date_of_birth) ? dayjs(owner.date_of_birth) : undefined}
              >
                <DatePicker 
                  placeholder="MM/DD/YYYY"
                  format="MM/DD/YYYY"
                  suffixIcon={<CalendarOutlined />}
                  style={{ width: '100%' }}
                  value={owner.date_of_birth && dayjs(owner.date_of_birth) ? dayjs(owner.date_of_birth) : undefined}
                  onChange={(date) => updateBeneficialOwner(index, 'date_of_birth', date)}
                />
              </Form.Item>
            </div>

            <div className={styles['form-row']}>
              <Form.Item
                name={['beneficial_owners', index, 'ownership_percentage']}
                label={<span className={styles['required-label']}>{t('StoreEntryStep3.OwnershipPercentage')}</span>}
                rules={[
                  { required: true, message: t('StoreEntryStep3.Pleasepercentage') },
                  { 
                    pattern: /^(\d{1,2}(\.\d{1,2})?|100(\.0{1,2})?)%?$/,
                    message: '股份比例必须是0-100之间的数字，最多保留2位小数'
                  },
                  {
                    validator: async (_, value) => {
                      if (value) {
                        // 移除百分号并转换为数字
                        const num = parseFloat(value.replace('%', ''));
                        if (isNaN(num) || num > 100 || num < 0) {
                          throw new Error('股份比例必须在0-100%之间');
                        }

                        // 计算所有受益所有人的持股比例总和
                        const allValues = form.getFieldsValue().beneficial_owners;
                        const totalPercentage = allValues.reduce((sum: number, owner: any, i: number) => {
                          if (i === index) {
                            return sum + num;  // 使用当前正在验证的值
                          }
                          const ownerPercent = parseFloat((owner?.ownership_percentage || '0').replace('%', ''));
                          return sum + (isNaN(ownerPercent) ? 0 : ownerPercent);
                        }, 0);

                        if (totalPercentage > 100) {
                          throw new Error('所有受益所有人的持股比例总和不能超过100%');
                        }
                      }
                    }
                  }
                ]}
                className={styles['form-item-half']}
                initialValue={owner.ownership_percentage}
                validateTrigger={['onChange', 'onBlur']}
              >
                <Input
                  placeholder={t('StoreEntryStep3.EG')}
                  value={owner.ownership_percentage}
                  onChange={(e) => updateBeneficialOwner(index, 'ownership_percentage', e.target.value)}
                />
              </Form.Item>

              <Form.Item
                name={['beneficial_owners', index, 'government_id_type']}
                label={<span className={styles['required-label']}>{t('StoreEntryStep3.GovernmentType')}</span>}
                rules={[{ required: true, message: t('StoreEntryStep3.Pleasetype') }]}
                className={styles['form-item-half']}
                initialValue={owner.government_id_type}
              >
                <Select
                  placeholder="Passport"
                  value={owner.government_id_type}
                  onChange={(value) => updateBeneficialOwner(index, 'government_id_type', value)}
                >
                  <Option value="passport">{t('StoreEntryStep3.Passport')}</Option>
                  <Option value="drivers_license">{t('StoreEntryStep3.DriverLicense')}</Option>
                  <Option value="state_id">{t('StoreEntryStep3.StateID')}</Option>
                  <Option value="green_card">{t('StoreEntryStep3.GreenCard')}</Option>
                </Select>
              </Form.Item>
            </div>

            <div className={styles['form-row']}>
              <Form.Item
                name={['beneficial_owners', index, 'id_number']}
                label={<span className={styles['required-label']}>{t('StoreEntryStep3.IDNumber')}</span>}
                rules={[{ required: true, message: t('StoreEntryStep3.IDNumber') }]}
                className={styles['form-item-half']}
                initialValue={owner.id_number}
              >
                <Input
                  placeholder={t('StoreEntryStep3.IDNumber')}
                  value={owner.id_number}
                  onChange={(e) => updateBeneficialOwner(index, 'id_number', e.target.value)}
                />
              </Form.Item>

              <Form.Item
                name={['beneficial_owners', index, 'government_id_upload']}
                label={<span className={styles['required-label']}>{t('StoreEntryStep3.GovernmentUpload')}</span>}
                rules={[{ required: true, message: t('StoreEntryStep3.PleaseID') }]}
                className={styles['form-item-half']}
              >
                <Upload {...createUploadProps(Array.isArray(owner.government_id_upload) ? owner.government_id_upload : [], (fileList) => updateBeneficialOwner(index, 'government_id_upload', fileList))}>
                  <div className={styles['upload-button']}>
                    <PlusOutlined />
                    <div>{t('StoreEntryStep3.Upload')}</div>
                  </div>
                </Upload>
              </Form.Item>
            </div>
          </div>
        ))}

        <div className={styles['form-row']}>
          <Button type="primary" className={styles['add-button']} onClick={addBeneficialOwner}>
            {t('StoreEntryStep3.AddOwners')}
          </Button>
        </div>

        <div className={styles['section-title']}>{t('StoreEntryStep3.ResidentialAddress')}</div>

        <div className={styles['form-row']}>
          <Form.Item
            name="first_name"
            label={<span className={styles['required-label']}>{t('StoreEntryStep3.FristName')}</span>}
            rules={[{ required: true, message: t('StoreEntryStep3.Pleasefname') }]}
            className={styles['form-item-half']}
          >
            <Input placeholder="Frist Name" />
          </Form.Item>

          <Form.Item
            name="last_name"
            label={<span className={styles['required-label']}>{t('StoreEntryStep3.LastName')}</span>}
            rules={[{ required: true, message: t('StoreEntryStep3.Pleaselname') }]}
            className={styles['form-item-half']}
          >
            <Input placeholder={t('StoreEntryStep3.LastName')} />
          </Form.Item>
        </div>

        <div className={styles['form-row']}>
          <Form.Item
            name="address"
            label={<span className={styles['required-label']}>{t('StoreEntryStep3.Address')}</span>}
            rules={[{ required: true, message: t('StoreEntryStep3.Pleaseaddress') }]}
            className={styles['form-item-full']}
          >
            <Input placeholder={t('StoreEntryStep3.Address')} />
          </Form.Item>
        </div>

        <div className={styles['form-row']}>
          <Form.Item
            name="building"
            label={<span className={styles['required-label']}>{t('storeEntry.AptSuiteBuilding')}</span>}
            className={styles['form-item-half']}
          >
            <Input placeholder={t('storeEntry.AptSuiteBuilding')} />
          </Form.Item>

          <Form.Item
            name="zip_code"
            label={<span className={styles['required-label']}>*{t('storeEntry.ZipCode')}</span>}
            rules={[{ required: true, message: t('storeEntry.Pleaseenterzipcode') }]}
            className={styles['form-item-half']}
          >
            <Input placeholder={t('storeEntry.ZipCode')} />
          </Form.Item>
        </div>

        <div className={styles['form-row']}>
          <Form.Item
            name="city"
            label={<span className={styles['required-label']}>*{t('storeEntry.CityOrTownship')}</span>}
            rules={[{ required: true, message: t('storeEntry.Pleaseentercityortownship') }]}
            className={styles['form-item-half']}
          >
            <Input placeholder={t('storeEntry.CityOrTownship')} />
          </Form.Item>

          <Form.Item
            name="state"
            label={<span className={styles['required-label']}>*{t('storeEntry.State')}</span>}
            rules={[{ required: true, message: t('storeEntry.Pleaseselectstate') }]}
            className={styles['form-item-half']}
          >
            <Select placeholder={t('storeEntry.State')}>
              {
                StateList.map((item, index) => (
                  <Option value={item.value} key={index}>{item.label}</Option>
                ))
              }
            </Select>
          </Form.Item>
        </div>
      </>
    );
  };

  // 渲染个人表单
  const renderIndividualForm = () => {
    return (
      <>
        <div className={styles['section-title']}>{t('StoreEntryStep3.IdentityCompliance')}</div>

        <div className={styles['form-row']}>
          <Form.Item
            name="legal_first_name"
            label={<span className={styles['required-label']}>*{t('StoreEntryStep3.LegalFirst')}</span>}
            rules={[{ required: true, message: t('StoreEntryStep3.Pleasename') }]}
            className={styles['form-item-half']}
          >
            <Input placeholder={t('StoreEntryStep3.LegalFirst')} />
          </Form.Item>

          <Form.Item
            name="date_of_birth"
            label={<span className={styles['required-label']}>*{t('StoreEntryStep3.DateBirth')}</span>}
            rules={[{ required: true, message: t('StoreEntryStep3.Pleasebirth') }]}
            className={styles['form-item-half']}
          >
            <DatePicker
              placeholder="MM/DD/YYYY"
              format="MM/DD/YYYY"
              suffixIcon={<CalendarOutlined />}
              style={{ width: '100%' }}
              value={formData?.date_of_birth && dayjs(formData.date_of_birth) ? dayjs(formData.date_of_birth) : undefined}
            />
          </Form.Item>
        </div>

        <div className={styles['form-row']}>
          <Form.Item
            name="ssn_itin_last4"
            label={<span className={styles['required-label']}>{t('StoreEntryStep3.SSN4')}</span>}
            rules={[{ required: true, message: t('StoreEntryStep3.Pleaseigits') }]}
            className={styles['form-item-half']}
          >
            <Input placeholder={t('StoreEntryStep3.SSN4')} maxLength={4} />
          </Form.Item>

          <Form.Item
            name="government_id_type"
            label={<span className={styles['required-label']}>{t('StoreEntryStep3.GovernmentType')}</span>}
            rules={[{ required: true, message: t('StoreEntryStep3.Pleasetype')}]}
            className={styles['form-item-half']}
          >
            <Select placeholder={t('StoreEntryStep3.Passport')}>
              <Option value="passport">{t('StoreEntryStep3.Passport')}</Option>
              <Option value="drivers_license">{t('StoreEntryStep3.DriverLicense')}</Option>
              <Option value="state_id">{t('StoreEntryStep3.StateID')}</Option>
              <Option value="green_card">{t('StoreEntryStep3.GreenCard')}</Option>
            </Select>
          </Form.Item>
        </div>

        <div className={styles['form-row']}>
          <Form.Item
            name="id_number"
            label={<span className={styles['required-label']}>{t('StoreEntryStep3.IDNumber')}</span>}
            rules={[{ required: true, message: t('StoreEntryStep3.Pleasenumber') }]}
            className={styles['form-item-half']}
          >
            <Input placeholder={t('StoreEntryStep3.IDNumber')} />
          </Form.Item>

          <Form.Item
            name="government_id_upload"
            label={<span className={styles['required-label']}>{t('StoreEntryStep3.GovernmentUpload')}</span>}
            rules={[{ required: true, message: t('StoreEntryStep3.PleaseID') }]}
            className={styles['form-item-half']}
          >
            <Upload {...createUploadProps(governmentIdFileList, setGovernmentIdFileList)}>
              <div className={styles['upload-button']}>
                <PlusOutlined />
                <div>{t('StoreEntryStep3.Upload')}</div>
              </div>
            </Upload>
          </Form.Item>
        </div>

        <div className={styles['form-row']}>
          <Form.Item
            name="tax_form_selection"
            label={<span className={styles['required-label']}>{t('StoreEntryStep3.TaxSelection')}</span>}
            rules={[{ required: true, message: t('StoreEntryStep3.Pleaseselection') }]}
            className={styles['form-item-full']}
          >
            <Select placeholder={t('storeEntry.Pleaseselect')}>
              <Option value="w9">{t('StoreEntryStep3.W9')}</Option>
              <Option value="w8ben">{t('StoreEntryStep3.W8BEN')}</Option>
            </Select>
          </Form.Item>
        </div>

        <div className={styles['section-title']}>{t('StoreEntryStep3.ResidentialAddress')}</div>

        <div className={styles['form-row']}>
          <Form.Item
            name="first_name"
            label={<span className={styles['required-label']}>*{t('StoreEntryStep3.FristName')}</span>}
            rules={[{ required: true, message: t('StoreEntryStep3.Pleasefname') }]}
            className={styles['form-item-half']}
          >
            <Input placeholder={t('StoreEntryStep3.FristName')} />
          </Form.Item>

          <Form.Item
            name="last_name"
            label={<span className={styles['required-label']}>{t('StoreEntryStep3.LastName')}</span>}
            rules={[{ required: true, message: t('StoreEntryStep3.Pleaselname') }]}
            className={styles['form-item-half']}
          >
            <Input placeholder={t('StoreEntryStep3.LastName')} />
          </Form.Item>
        </div>

        <div className={styles['form-row']}>
          <Form.Item
            name="address"
            label={<span className={styles['required-label']}>{t('StoreEntryStep3.Address')}</span>}
            rules={[{ required: true, message: t('StoreEntryStep3.Pleaseaddress') }]}
            className={styles['form-item-full']}
          >
            <Input placeholder={t('StoreEntryStep3.Address')} />
          </Form.Item>
        </div>

        <div className={styles['form-row']}>
          <Form.Item
            name="building"
            label={<span className={styles['required-label']}>{t('StoreEntryStep3.AptBuilding')}</span>}
          
            className={styles['form-item-half']}
          >
            <Input placeholder={t('storeEntry.AptSuiteBuilding')} />
          </Form.Item>

          <Form.Item
            name="zip_code"
            label={<span className={styles['required-label']}>{t('StoreEntryStep3.ZipCode')}</span>}
            rules={[{ required: true, message: t('StoreEntryStep3.Pleasecode') }]}
            className={styles['form-item-half']}
          >
            <Input placeholder={t('storeEntry.ZipCode')} />
          </Form.Item>
        </div>

        <div className={styles['form-row']}>
          <Form.Item
            name="city"
            label={<span className={styles['required-label']}>{t('StoreEntryStep3.CityTownship')}</span>}
            rules={[{ required: true, message: t('StoreEntryStep3.Pleasetownship') }]}
            className={styles['form-item-half']}
          >
            <Input placeholder={t('storeEntry.CityOrTownship')} />
          </Form.Item>

          <Form.Item
            name="state"
            label={<span className={styles['required-label']}>{t('StoreEntryStep3.State')}</span>}
            rules={[{ required: true, message: t('StoreEntryStep3.Pleasestate') }]}
            className={styles['form-item-half']}
          >
            <Select placeholder={t('storeEntry.State')}>
              {
                StateList.map((item, index) => (
                  <Option value={item.value} key={index}>{item.label}</Option>
                ))
              }
            </Select>
          </Form.Item>
        </div>
      </>
    );
  };

  return (
    <div className={styles['store-entry-step3']}>
      <div className={styles['header']}>
        <div className={styles['header-title']}>{t('StoreEntryStep3.IdentityCompliance')}</div>
        <div className={styles['header-protection']}>
          <span className={styles['protection-icon']}>✓</span>
          {t('StoreEntryStep3.YourOut')}
        </div>
      </div>

      <Form form={form} layout="vertical">
        {storeType === 'business' ? renderBusinessForm() : renderIndividualForm()}

        {/* 按钮区域 */}
        <div className={styles['button-container']}>
          <Button
            className={styles['back-button']}
            onClick={onPrev}
          >
            {t('StoreEntryStep3.Back')}
          </Button>
          <Button
            type="primary"
            className={styles['next-button']}
            onClick={handleSubmit}
          >
            {t('StoreEntryStep3.Next')}
          </Button>
        </div>
      </Form>

      {/* 添加预览Modal */}
      <Modal
        open={previewVisible}
        title={previewTitle}
        width={"80%"}
        footer={null}
        onCancel={() => setPreviewVisible(false)}
      >
        <img alt={previewTitle} style={{ width: '100%' }} src={previewImage} />
      </Modal>
    </div>
  );
};

export default StoreEntryStep3; 